<template>
  <div
    class="rating-table"
    v-bind:class="{ visible: isVisible }"
  >
    <p v-if="isLoading">Загрузка таблицы...</p>

    <template v-else>
      <div class="heading">
        <select v-model="ratingType" v-if="interactive">
          <option value="general">Рейтинг таблица</option>
          <option value="lol">ХаХа-рейтинг таблица</option>
        </select>

        <template v-else>
          <span v-if="ratingType === 'general'">Рейтинг таблица</span>
          <span v-else>XаXа-рейтинг таблица</span>
        </template>

        <!-- <button
          class="rating-type-switch"
          v-if="ratingType === 'general'"
          v-on:click="switchRatingType('lol')"
        >🤣</button>
        <button
          class="rating-type-switch"
          v-if="ratingType === 'lol'"
          v-on:click="switchRatingType('general')"
        >👍</button> -->
      </div>

      <RatingTable
        v-bind:class="`rating-type-${ratingType}`"
        v-bind:ratingList="ratingList"
        v-bind:roundQty="maxRounds"
        v-bind:perPage="perPage"
        v-bind:showMedal="ratingType === 'general'"
      />

      <button
        class="button transparent button-icon-large close-rating-table"
        v-if="interactive"
        v-on:click="close"
      >
        <i class="icon icon__close icon-large"></i>
      </button>
    </template>
  </div>
</template>

<script>
import RatingRepo from '../../lib/RatingRepo';
import RatingTable from './RatingTable.vue';

export default {
  name: 'RatingTableWrapper',

  components: {
    RatingTable,
  },

  props: {
    gameId: {
      type: String,
      required: true,
    },

    interactive: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: false,
      isVisible: false,
      perPage: 0,
      currentPage: 0,
      pagesList: [],

      maxRounds: 0,
      ratingListGeneral: [],
      ratingListLol: [],

      ratingType: 'general',

      rotationIntervalId: null,
    };
  },

  computed: {
    ratingList() {
      // if (this.pagesList.length <= 0) return this.ratingListGeneral;
      // if (!this.currentPage) return this.ratingListGeneral;
      // if (!this.pagesList[this.currentPage]) return this.ratingListGeneral;

      const [ratingType, currentPageStr] = this.currentPageKey.split('_');

      const rating = ratingType === 'general'
        ? this.ratingListGeneral
        : this.ratingListLol;

      const currentPage = parseInt(currentPageStr, 10);

      return rating.slice(currentPage * this.perPage, (currentPage + 1) * this.perPage);
      // return this.ratingType === 'general'
      //   ? this.ratingListGeneral
      //   : this.ratingListLol;
    },

    currentPageKey() {
      return this.pagesList[this.currentPage] || 'general_0';
    },
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.calcPerPage);

    this.stopRotation();
  },

  mounted() {
    console.log('RatingMounted');

    setTimeout(() => {
      this.isVisible = true;
    }, 250);

    this.calcPerPage();

    window.addEventListener('resize', this.calcPerPage, false);
  },

  created() {
    this.isLoading = true;

    RatingRepo.getCombinedRatingTable(this.gameId)
      .then(({ general, lol, maxRounds }) => {
        this.ratingListGeneral = general;
        this.ratingListLol = lol;
        this.maxRounds = maxRounds;
      })
      .catch(err => console.warn('Failed to get rating', err))
      .then(() => {
        this.isLoading = false;

        this.updatePages();
        this.startRotation();
      });
  },

  methods: {
    close() {
      this.isVisible = false;

      setTimeout(() => {
        this.$emit('close');
      }, 250);
    },

    startRotation() {
      if (this.interactive) return;

      this.rotationIntervalId = setInterval(() => {
        if (this.pagesList.length > 0) {
          this.currentPage = (this.currentPage + 1) % this.pagesList.length;
          const [ratingType] = (this.pagesList[this.currentPage] || 'general_0').split('_');
          this.ratingType = ratingType;
          // console.log('rotation tick -> %s', this.currentPage);
          // console.log(this.pagesList);
          // console.log(this.currentPage);
        }
      }, 6e3);
    },

    stopRotation() {
      if (this.rotationIntervalId) {
        this.rotationIntervalId = clearInterval(this.rotationIntervalId);
        console.log('stop rotation');
      }
    },

    calcPerPage() {
      this.perPage = document.documentElement.clientHeight > 600 ? 10 : 5;
      this.updatePages();
    },

    updatePages() {
      const generalPages = Math.ceil(this.ratingListGeneral.length / this.perPage);
      const lolPages = Math.ceil(this.ratingListLol.length / this.perPage);

      this.pagesList = (new Array(generalPages))
        .fill('').map((_, idx) => `general_${idx}`)
        .concat(
          (new Array(lolPages))
            .fill('').map((_, idx) => `lol_${idx}`),
        );
    },

    switchRatingType(type) {
      this.ratingType = type;
    },
  },
};
</script>
